import fetch from './fetch'

export function login (email: string, password: string): Promise<api.auth.LoginResponse> {
  return fetch.post('/login', { email, password }).then(res => res.data)
}
